// extracted by mini-css-extract-plugin
var _1 = "MobileScaledAnswer_itemLabel__a89c1";
var _2 = "MobileScaledAnswer_itemMask__4af7e";
var _3 = "MobileScaledAnswer_scaledAnswer__f2d87";
var _4 = "MobileScaledAnswer_textInner__3847e";
export { _1 as "itemLabel", _2 as "itemMask", _3 as "scaledAnswer", _4 as "textInner" }
